if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if(!this.querySelector('form').checkValidity()) {
          let input_selectors = ['.bp-name-input'];
          for (var index in input_selectors) {
            let selector = input_selectors[index];
            if (this.handlePetPosterInputs(selector))
            return
          }
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Only a portrait the customer generated can be bought. Without one the
        // order either fails after payment (#1121, #1147) or prints the style's
        // sample artwork instead of their pet (#1153, #1185).
        const portrait_input = document.querySelector('.bp-ai-portrait-url');
        if (portrait_input && !portrait_input.value.trim()) {
          const error_el = document.querySelector('.bp-ai-error');
          this.handleErrorMessage((error_el && error_el.dataset.errorNoPortrait) || 'Please upload your pet\'s photo and create the portrait first.');
          if (error_el && error_el.parentElement) error_el.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if(typeof no_of_babies !== 'undefined') {
          if(no_of_babies < 3) {
            if($('#bp-heading-value1').length) {
              let items = $('.petposter-template .bp-poster-headline > *');
              let headline = '';

              items.each(function(i, item){
                var attr = $(item).attr('data-input');
                var index = $(item).attr('data-index');
                if(typeof attr !== 'undefined' && attr !== false) {
                  let val = $(`${$(item).attr("data-input")}`).val().trim();
                  if(index == "2") {
                    headline += ' &';
                  }
                  headline += ' ';
                  headline += val;
                }
                else if($(item).css("display") !== "none") {
                  headline += ' '
                  headline += $(item).text().trim();
                }
              });

              $('#bp-heading-value1').val(headline.trim());
            }
          }
          else {
            for(var i=1; i <= no_of_babies; i++) {
              if($(`#bp-heading-value${i}`).length) {
                let items = $(`.petposter-template .bp-poster-info[data-index="${i}"] .bp-poster-headline > *`);
                let headline = '';

                items.each(function(i, item){
                  var attr = $(item).attr('data-input');
                  if(typeof attr !== 'undefined' && attr !== false) {
                    let val = $(`${$(item).attr("data-input")}`).val().trim();
                    headline += ' '
                    headline += val;
                  }
                  else if($(item).css("display") !== "none") {
                    headline += ' '
                    headline += $(item).text().trim();
                  }
                });

                $(`#bp-heading-value${i}`).val(headline.trim());
              }
            }
          }
          for(var i=1; i <= no_of_babies; i++) {
            if($(`#bp-subheading-value${i}`).length) {
              // Three-way: explicit "No subheading" → empty.
              // Otherwise "Custom text" → typed value. Otherwise breed/date pair.
              if($(`#bp-no-subheading-${i}`).val() === 'true') {
                $(`#bp-subheading-value${i}`).val('');
              } else if($(`#bp-custom-text-flag-${i}`).val() === 'true' && $(`#bp-custom-text-${i}`).val().trim() !== '') {
                $(`#bp-subheading-value${i}`).val($(`#bp-custom-text-${i}`).val().trim().toUpperCase());
              } else {
                let breed = ($(`#breed-current-${i}`).length) ? $(`#breed-current-${i}`).val() : $(`.petposter-template .bp-breed[data-index="${i}"]`).text();
                let date = ($(`#date-current-${i}`).length) ? $(`#date-current-${i}`).val() : $(`.petposter-template .bp-date[data-index="${i}"]`).text();

                let subheading = [breed, date].filter(str => str !== "").join(' / ').trim();
                $(`#bp-subheading-value${i}`).val(subheading);
              }
            }
          }
        }

        // The portrait's file name carries the style it was generated in, and
        // that beats the page's ?style= param: a saved creation loaded on
        // another style's page (or on a page with no style at all) is still
        // the style it was painted in.
        let portrait_style = String($('.bp-ai-portrait-url').val() || '').match(/pet-portrait-\d+-style-([a-z0-9-]+?)(?:-clean)?\.png/i);
        if(portrait_style) $('#bp-style-handle').val(portrait_style[1].toLowerCase());

        let url_element = $('.bp-url');
        if(url_element.length){
          let myform = $(this.form);
          url_element.val(this.makeURL(myform));
        }

        // The customizer no longer writes the "View your poster" line item
        // property — it leaked another click out of the conversion funnel
        // and Shopify CDN forced .html downloads anyway. The personalized
        // preview still travels with the order via `_preview_url` (cart
        // drawer thumbnail + webhook fallback for upscale source).
        let preview_element = $('.bp-preview-url');
        if(preview_element.length){
          let preview_img = document.querySelector(".hidden-preview .bp-poster-preview .bp-illustration-img");
          try {
            // No portrait generated → the print original is what gets printed,
            // so the cart preview must show it, not the tool display image.
            if (preview_img && window.ppToolDisplayImage && !$('.bp-ai-portrait-url').val()) {
              const printOriginal = $('.bp-current-illustration-url').val();
              if (printOriginal && preview_img.getAttribute('src') === window.ppToolDisplayImage) {
                preview_img.setAttribute('src', printOriginal.startsWith('//') ? 'https:' + printOriginal : printOriginal);
              }
            }
            if(preview_img) {
              // Saved-artwork clicks and page reloads leave the hidden preview
              // pointing at a REMOTE URL, which taints the canvas in domtoimage
              // → blank screenshot (order #1025). Force-convert to data: URL
              // here so the screenshot path is CORS-safe regardless of origin.
              const src = preview_img.getAttribute('src') || '';
              if (src && !src.startsWith('data:')) {
                try {
                  const r = await fetch(src, { mode: 'cors', credentials: 'omit' });
                  if (!r.ok) throw new Error('fetch ' + r.status);
                  const blob = await r.blob();
                  const dataUrl = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = () => reject(new Error('FileReader failed'));
                    reader.readAsDataURL(blob);
                  });
                  // Force-wait for the NEW src to decode. Setting src is
                  // asynchronous and `img.complete` can still be true for the
                  // OLD src for a microtask after assignment — leading to the
                  // screenshot firing before the data URL paints (the #1025
                  // bug). Wait on the `load` event explicitly.
                  await new Promise((resolve, reject) => {
                    const onLoad = () => { cleanup(); resolve(); };
                    const onErr = () => { cleanup(); reject(new Error('img load')); };
                    const cleanup = () => {
                      preview_img.removeEventListener('load', onLoad);
                      preview_img.removeEventListener('error', onErr);
                    };
                    preview_img.addEventListener('load', onLoad);
                    preview_img.addEventListener('error', onErr);
                    preview_img.setAttribute('src', dataUrl);
                  });
                  // Extra paint yield — domtoimage walks the DOM synchronously
                  // and benefits from one rAF tick after a fresh image decode.
                  await new Promise((r) => requestAnimationFrame(() => r()));
                } catch (e) {
                  console.warn('[product-form] preview→base64 conversion failed, screenshot may be blank:', e.message);
                  await this.imageLoaded(preview_img); // fall back to original wait
                }
              } else {
                await this.imageLoaded(preview_img);
              }
            }
            let file = await this.takeScreenshot()
            // Sanity check: a real composed preview is ≥10KB. A canvas-tainted
            // run produces a tiny solid-colour PNG (~1-2KB). Better to fail the
            // add-to-cart than ship a blank thumbnail to cart/checkout/admin.
            if (file && file.size < 8000) {
              // Used to throw and abort the add-to-cart. That made sense when the
              // screenshot was the only record of the design; now the cart falls
              // back to __ai_portrait or __photo, so a blank shot costs a nicer
              // thumbnail rather than the whole order. Drop the preview, carry on.
              console.warn('[product-form] preview screenshot looks blank (' + file.size + ' bytes) — skipping preview, add-to-cart continues');
              file = null;
            }
            if(file) {
              // The .bp-preview-url input is now type=hidden — we no longer
              // attach the screenshot as a file (Shopify Files upload). Instead
              // we upload the preview to Vercel Blob and set "Your Design" to
              // a designed preview-page URL that opens in checkout instead of
              // a raw image download. The preview URL also feeds the cart
              // drawer's personalized thumbnail.

              // Upload preview to Vercel Blob for permanent URL (checkout, emails, order admin)
              try {
                var apiBase = (typeof AI_API_URL !== 'undefined' ? AI_API_URL : 'https://petposter.vercel.app');
                var reader = new FileReader();
                var base64Promise = new Promise(function(resolve) {
                  reader.onload = function() { resolve(reader.result); };
                  reader.readAsDataURL(file);
                });
                var base64Data = await base64Promise;
                var uploadResp = await fetch(apiBase + '/api/upload-preview', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ image: base64Data })
                });
                if (uploadResp.ok) {
                  var uploadData = await uploadResp.json();
                  if (uploadData.url) {
                    // _preview_url — used by cart drawer thumbnail + webhook fallback
                    var previewUrlInput = this.form.querySelector('input[name="properties[_preview_url]"]');
                    if (!previewUrlInput) {
                      previewUrlInput = document.createElement('input');
                      previewUrlInput.type = 'hidden';
                      previewUrlInput.name = 'properties[_preview_url]';
                      this.form.appendChild(previewUrlInput);
                    }
                    previewUrlInput.value = uploadData.url;
                    console.log('[product-form] Preview uploaded:', uploadData.url);

                    // No "View your poster" property anymore — removed
                    // deliberately to avoid leaking a click out of the
                    // conversion funnel. The cart drawer + webhook still
                    // get the preview via `_preview_url` above.
                  }
                }
              } catch (uploadErr) {
                console.warn('[product-form] Preview upload failed (non-blocking):', uploadErr.message);
              }
            }
          } catch (error) {
              preview_element[0].value = ''
              console.error(error);
          }
        }

        var formData = new FormData(this.form);
        formData = this.autoContrastTweak(formData);

        const frame_selector = $(`[name="frame-selector"]:checked`);
        if (frame_selector.length && frame_selector.val() != "no_frame"){
          // The frame radio's value attribute is server-rendered with the variant ID
          // matching the INITIAL poster size at page-load. If the customer changed
          // the poster size after that, the radio's value is stale (visual price
          // updates via a separate handler, but the variant ID doesn't). Look up
          // window.frameData with the current poster size + frame title to get the
          // correct variant ID for THIS size.
          let resolvedFrameId = frame_selector.val();
          try {
            const frameTitle = frame_selector.attr('data-title') || '';
            const currentSize = $('.bp-variant-options-radio:checked').val() || '';
            if (frameTitle && currentSize && typeof window.frameData === 'object' && window.frameData) {
              for (const handle in window.frameData) {
                const fp = window.frameData[handle];
                if (fp && fp.title === frameTitle && fp.variants && fp.variants[currentSize]) {
                  resolvedFrameId = String(fp.variants[currentSize].id);
                  break;
                }
              }
            }
          } catch (e) {
            console.warn('[product-form] frame variant resolution failed, falling back to radio value:', e);
          }

          var pd_obj = {};
          for (const p of formData.entries()){
            pd_obj[p[0]] = p[1]
          }
          formData = new FormData();
          var frame_obj = { 'id': resolvedFrameId, 'quantity': pd_obj.quantity }
          var items = [frame_obj, pd_obj];
          items.forEach((obj, index) => {
            Object.entries(obj).forEach(([key, value]) => {
              formData.append(`items[${index}][${key}]`, value);
            });
          });
          // Force the frame line item to be unique on each ATC so Shopify
          // doesn't merge it with a previously-added identical frame variant.
          // Without this, two posters added with the same frame end up
          // sharing ONE frame line item (qty=2), which breaks per-poster
          // pairing in the cart drawer (only the first poster gets a chip).
          var frameSeq = Date.now() + '-' + Math.random().toString(36).slice(2, 9);
          formData.append('items[0][properties][_pp_frame_seq]', frameSeq);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Fire AddToCart tracking across GA4, Shopify Customer Events (→ F&I Pixel/CAPI), Klaviyo.
            try {
              var addedItems = Array.isArray(response.items) ? response.items : [response];
              var first = addedItems[0] || {};
              var currency = first.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
              var totalValue = addedItems.reduce(function (s, i) {
                return s + ((i.final_price || i.price || 0) * (i.quantity || 1));
              }, 0) / 100;
              var ga4Items = addedItems.map(function (i) {
                return {
                  item_id: String(i.variant_id || i.id),
                  item_name: i.product_title || i.title || '',
                  price: (i.final_price || i.price || 0) / 100,
                  quantity: i.quantity || 1,
                };
              });

              if (window.gtag) {
                window.gtag('event', 'add_to_cart', { currency: currency, value: totalValue, items: ga4Items });
              }
              // Publish to Shopify's Customer Events bus so sandboxed pixels
              // (Facebook & Instagram channel, TikTok, etc.) receive AJAX cart-adds
              // they would otherwise miss. F&I forwards to Meta via Pixel + CAPI.
              if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
                addedItems.forEach(function (i) {
                  var unitPrice = (i.final_price || i.price || 0) / 100;
                  Shopify.analytics.publish('product_added_to_cart', {
                    cartLine: {
                      cost: {
                        totalAmount: {
                          amount: unitPrice * (i.quantity || 1),
                          currencyCode: currency,
                        },
                      },
                      merchandise: {
                        id: String(i.variant_id || i.id),
                        title: i.variant_title || i.title || '',
                        vendor: i.vendor || '',
                        sku: i.sku || '',
                        product: {
                          id: String(i.product_id || i.variant_id || i.id),
                          title: i.product_title || i.title || '',
                          vendor: i.vendor || '',
                          type: i.product_type || '',
                          url: i.url || '',
                        },
                        price: { amount: unitPrice, currencyCode: currency },
                        image: { src: i.image || '' },
                      },
                      quantity: i.quantity || 1,
                    },
                  });
                });
              }
              if (window.klaviyo && window.klaviyo.push) {
                window.klaviyo.push(['track', 'Added to Cart', {
                  $value: totalValue,
                  AddedItemProductName: first.product_title || first.title,
                  AddedItemProductID: String(first.product_id || first.variant_id || first.id || ''),
                  AddedItemSKU: first.sku || '',
                  AddedItemQuantity: first.quantity || 1,
                  AddedItemPrice: (first.final_price || first.price || 0) / 100,
                  ItemNames: ga4Items.map(function (i) { return i.item_name; }),
                }]);
              }
              if (window.posthog && window.posthog.capture) {
                window.posthog.capture('add_to_cart', {
                  value: totalValue,
                  currency: currency,
                  num_items: addedItems.reduce(function (s, i) { return s + (i.quantity || 1); }, 0),
                  product_title: first.product_title || first.title || '',
                  product_id: String(first.product_id || ''),
                  variant_id: String(first.variant_id || first.id || ''),
                  item_names: ga4Items.map(function (i) { return i.item_name; }),
                  // Same key pp_generate sends, so generate → cart can be read
                  // per style. 'none' means the customer never came through a
                  // style page.
                  style: ((document.getElementById('bp-style-handle') || {}).value || '').toLowerCase() || 'none',
                });
              }
              console.log('[pp-track] AddToCart fired', { value: totalValue, currency: currency, items: ga4Items });
            } catch (trackErr) {
              console.warn('[pp-track] AddToCart tracking failed:', trackErr);
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handlePetPosterInputs(selector) {
        let input_fields = document.querySelectorAll(selector);
        if(input_fields) {
          for (let i=0; i < input_fields.length; i++) {
            let input_field = input_fields[i];
            if(input_field && !input_field.checkValidity()) {
              input_field.closest('.bp-sidebar-item').querySelector('.bp-sidebar-item-radio').labels[0].click();
              input_field.classList.add('bp-input-error');
              return true;
            }
          }
        }
        return false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      makeURL(form) {
        let formData = form.serializeArray();
        formData = formData.filter(item => (item.value != '' || by_default_valued_properties.some(prop => item.name.includes(prop))));
        formData = formData.filter(item => (item.name.includes('properties') || item.name.includes('prop') || item.name.includes('frame-selector')))
        formData = formData.filter(item => !form_filters.some(filter => item.name.includes(filter)))

        const jsonString = JSON.stringify(formData);
        let sp_encoded_string = window.myVerifiedEncoding(jsonString)
        const encoded_string = encodeURIComponent(sp_encoded_string);

        var url_visit = new URL(window.location.href);
        url_visit.searchParams.append("values", encoded_string);
        return url_visit.href
      }

      autoContrastTweak(formData) {
        if (typeof no_of_babies === 'undefined') return formData;
        let bg_color = formData.get('properties[__background]');
        for(var i=1; i <= no_of_babies; i++) {
          let clr = formData.get(`properties[__color_${i}]`);
          let illustration = $(`.bp-variant-options-radio[data-index="${i}"]:checked`).attr('data-value');
          let illustration_swatches = $(`.bp-illustration-block[data-index="${i}"] .bp-swatch-container`);

          if(illustration_swatches.length < 2
            && !illustration.includes("aquarelle")
            && clr == "black"
            && bg_color == "black"
          ) {
            formData.set(`properties[__color_${i}]`, "white");
          }
        }
        return formData
      }

      takeScreenshot(){
        $('.bp-viewbox').val('');

        function svgDataUrlToDirectBlob(svgDataUrl) {
          const svgContent = svgDataUrl.replace(/^data:image\/svg\+xml;charset=utf-8,/, '')
          .replace(/<svg([^>]+)width="(\d+)" height="(\d+)"/,
            (match, p1, width, height) => {
                $('.bp-viewbox').val(`0 0 ${width} ${height}`);
                return `<svg${p1} viewBox="0 0 ${width} ${height}"`;
          });
          return new Blob([unescape(svgContent)], { type: "image/svg" });
        }

        const response = new Promise (function (resolve, reject) {
          let element = document.querySelector(".hidden-preview .bp-preview-illustration") || document.querySelector(".hidden-preview .bp-poster-preview");
          const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                  navigator.userAgent
                  && navigator.userAgent.indexOf('CriOS') == -1
                  && navigator.userAgent.indexOf('FxiOS') == -1
                  && !navigator.userAgent.match('FxiOS')
                  && navigator.userAgent.indexOf('OPT') == -1 ;

          if (isSafari) {
            domtoimage.toSvg(element, { width: element.offsetWidth, height: element.offsetHeight }).then(dataUrl => {
              let blob = svgDataUrlToDirectBlob(dataUrl);
              let file = new File([blob], 'preview.svg', {type: blob.type});
              resolve(file);
            })
            .catch(function (error) {
              console.error('oops, something went wrong!', error);
              reject('');
            });
          } else {
            domtoimage.toBlob(element, { width: element.offsetWidth, height: element.offsetHeight }).then(blob => {
              let file = new File([blob], 'preview.jpg', {type: blob.type});
              resolve(file);
            })
            .catch(function (error) {
              console.error('oops, something went wrong!', error);
              reject('');
            });
          }
        })
        return response;
      }
      imageLoaded(img) {
        return new Promise((resolve, reject) => {
            // Check if the image is already loaded
            if (img.complete && img.naturalHeight !== 0) {
                resolve();
            } else {
              // Set up event listeners to resolve or reject the promise
              img.addEventListener('load', () => resolve());
              img.addEventListener('error', () => reject(new Error('Failed to load image')));
            }
        });
      }
    }
  );
}
